import { BasicMenuItemOption } from 'ui/menu';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Upload, Delete24, Reset24 } from 'ui/icons';

const BossBadge = styled.span`
  border: 1px solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  color: ${colors.textPrimary};
  margin-left: ${spacing.quarter};
  padding: ${spacing.eighth} ${spacing.threeEights};
  background: inherit;
  font: inherit;
`;

const IconOption = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.threeQuarter};
`;

const DeleteOption = styled.div`
  color: ${colors.negative100};
`;

export const MENU_OPTION: Record<string, BasicMenuItemOption> = {
  ARCHIVE_FLOW: {
    content: 'Archive flow',
    id: 'archive-flow',
  },
  SAVE_AS_IMAGE: {
    content: (
      <IconOption>
        <Upload height={26} width={26} color={colors.grey35} />
        Save as image
      </IconOption>
    ),
    id: 'save-as-image',
  },
  DELETE_DRAFT: {
    content: (
      <IconOption>
        <Delete24 color={colors.grey35} /> <DeleteOption>Delete draft</DeleteOption>
      </IconOption>
    ),
    id: 'delete-draft',
  },
  RESET_TO_PUBLISHED: {
    content: (
      <IconOption>
        <Reset24 color={colors.grey35} /> Reset draft
      </IconOption>
    ),
    id: 'reset-to-published',
  },
  FIX_STUCK_USERS: {
    content: (
      <>
        Fix stuck users <BossBadge>Boss</BossBadge>
      </>
    ),
    id: 'fix-stuck-users',
  },
  DIVIDER: {
    isDivider: true,
    id: 'menu-divider',
    label: '',
  },
};
